import React from 'react'
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '../../../js/AppState';
import Popup from '../../shared/Popup/Popup';

import './PopupMentionLegales.css'
import Texts from 'react-sdk/Texts';

const PopupMentionLegales = () => {

  console.log("PopupMentionLegales")

  function handleClose() {
    PopupsManager.close(POPUPS.MENTIONS_LEGALES)
  }

  return (
    <div className="PopupMentionLegales" >        
        <div className="Popup" >
          <div className="Popup-close" onClick={() => handleClose() }><p>&times;</p></div>
          <div className="content" >
            <h2>{Texts.get("mentions-legales-title")}</h2>
            <div className="text" dangerouslySetInnerHTML={{__html: Texts.get("mentions-legales-text")}} />
        </div>
      </div>
    </div>
  );
};

export default PopupMentionLegales;
